import { useQuery } from "@apollo/client"
import { GET_USER_RECEIPTS } from "../graphql/queries/getUserReceipts"

export const useUserReceipts = () => {
  const { data, error, loading, refetch } = useQuery(GET_USER_RECEIPTS, {})
  return { receiptsData: data?.myUser?.receipts, error, loading, refetch }
}
